import {RootStore} from './root.store';
import {makeAutoObservable} from 'mobx';
import {ErrorCode} from '../domains/errorCode';
import {IPaging, IRate} from '../domains/rate.domain';
import {getRates} from '../api/rate';

export class RateStore {
  root: RootStore;

  private _errorCode: ErrorCode | null = null;
  private _isLoading: boolean = false;
  private _shortName: string = '';
  private _searchField: string = '';
  private _pagingRates: IPaging<IRate> = {items: [], page: 0, pageSize: 0, totalCount: 0, totalPages: 0};

  constructor(root: RootStore) {
    makeAutoObservable(this);
    this.root = root;
  }

  init(shortName: string): void {
    this._shortName = shortName;
  }

  get pagingRates(): IPaging<IRate> {
    return this._pagingRates;
  }

  get searchField(): string {
    return this._searchField;
  }

  set searchField(value: string) {
    this._searchField = value.trim();
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  get errorCode(): ErrorCode | null {
    return this._errorCode;
  }

  setErrorCode(value: ErrorCode | null) {
    this._errorCode = value;
  }

  async searchRates(page: number): Promise<void> {
    this.setErrorCode(null);
    this._isLoading = true;
    try {
      if (this._searchField) {
        this._pagingRates = await getRates(this._shortName, this.searchField, page);
        if (this._pagingRates.items.length === 0) this.setErrorCode(ErrorCode.NoResultsFound);
      } else {
        this._pagingRates = {items: [], page: 0, pageSize: 0, totalCount: 0, totalPages: 0};
      }
    } catch (e) {
      if (e.status === 404) {
        this.setErrorCode(ErrorCode.NoResultsFound);
      } else {
        this.setErrorCode(ErrorCode.Undefined);
      }
    } finally {
      this._isLoading = false;
    }
  }
}
